// @flow
import * as React from "react";
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import { Carousel } from "antd";
import { handleToPortal } from "@/utils/sys";
import { useRouter } from "next/router";
import Image from "next/image";
import BannerPic from "@images/home/banner@2x.png";
type Props = {};
const Index = (props: Props) => {
  const { t, i18n } = useTranslation("home");
  const router = useRouter();
  const goHome = () => {
    window.location.href = process.env.publicUrl + "/";
  };
  return (
    <div className={`${styles.banner}`}>
      <div className={`${styles.container} flex items-center justify-center`}>
        <div className={`${styles.left}`}>
          {router.locale == "en"
            ? "TikTok E-commerce Data Analytics, Shoplus help you win on Tiktok business."
            : "TikTok电商分析，就用Shoplus"}
          <div
            className={styles.btn}
            onClick={() => {
              goHome();
            }}
          >
            {router.locale == "en" ? "Get Started" : "立即体验"}
          </div>
        </div>
        <div className={styles.pic}>
          <Image lazyBoundary="10px" src={BannerPic} alt=""></Image>
        </div>
      </div>
    </div>
  );
};

export default Index;
